import { Roles } from "../../constants/roles";
import { SNSPreviewManagerHandler } from "./sns-preview-manager-handler";
import { snsPreviewManagerForm } from "./sns-preview-manager-form";

class SNSPreviewManagerSetup {
    private static manager: SNSPreviewManagerHandler | null = null;

    private static readonly postCardSelector = `[data-role="${Roles.POST_CARD}"]`;

    private static readonly postCreateFormSelector = `[data-role="${Roles.POST_CREATE_FORM}"]`;

    private static readonly displayContentSelector = [
        `[data-role="${Roles.POST_DETAIL_CONTENT}"]`,
        `[data-role="${Roles.POST_CONTENT_DISPLAY}"]`,
    ].join(", ");

    public static getManager(): SNSPreviewManagerHandler {
        if (!(this.manager instanceof SNSPreviewManagerHandler)) {
            this.manager = new SNSPreviewManagerHandler();
        }

        return this.manager;
    }

    public static initAuto(): SNSPreviewManagerHandler {
        const manager = this.getManager();
        const hasPostCard = snsPreviewManagerForm.hasElement(document, this.postCardSelector);
        const hasPostCreateForm = snsPreviewManagerForm.hasElement(document, this.postCreateFormSelector);
        const hasDisplayContent = snsPreviewManagerForm.hasElement(document, this.displayContentSelector);

        if (hasPostCard) {
            manager.initForIndex(this.postCardSelector);
        }

        if (hasPostCreateForm) {
            manager.initializeForCreationPages();
        }

        if (!hasPostCard && hasDisplayContent) {
            manager.initForDisplay(this.displayContentSelector, false);
        }

        return manager;
    }
}

export { SNSPreviewManagerSetup };
